// dependencies
import React from 'react'
import { Box } from '@mui/material'
// components
import ProductTile from '@components/product/product-tile'
import ProductTileMiniWrapper from '@components/product/ProductTileMini/ProductTileMiniWrapper'
import CategoryTileV2 from '../CategoryTileV2'
import StrapiMarkdown from '../Markdown'

const generateItemKey = item => (typeName = '') =>
  `${item.__typename}-${item?.[typeName]?.id || item?.[typeName]}`.toLowerCase()

export const renderProductTile = (index, sku, key, couponSliderSkus) => (
  // Note: sliders with a coupon tile normally render with full product tiles on mobile, rather than the default mini tile.Alignment
  // For this content type, we'll ignore this startegy for now
  // if (couponSliderSkus?.length > 0) {
  //   const isCouponProductTile = couponSliderSkus.includes(sku)
  //   return (
  //     <Box
  //       sx={{
  //         height: '100%',
  //         width: { xs: '75vw', sm: 'auto' },
  //         paddingRight: isCouponProductTile ? '6px' : 0,
  //         '& .MuiCardContent-root': {
  //           width: 'auto',
  //         },
  //       }}
  //     >
  //       <ProductTile
  //         index={index}
  //         id={`product-title:${sku}`}
  //         sku={sku}
  //         source="strapi-slider"
  //         antiFlickering
  //         showSwatches
  //         key={key}
  //         featureVariant="strapi-slider"
  //       />
  //     </Box>
  //   )
  // }
  <>
    <Box
      sx={{
        height: '100%',
        display: { xs: 'none', sm: 'block', md: 'block' },
        '& .MuiCardContent-root': {
          width: 'auto',
        },
      }}
    >
      <ProductTile
        index={index}
        id={`product-title:${sku}`}
        sku={sku}
        source="strapi-slider"
        antiFlickering
        showSwatches
        key={key}
        featureVariant="strapi-slider"
      />
    </Box>
    <Box
      sx={{
        height: '100%',
        display: { md: 'none', sm: 'none', xs: 'block' },
        '& .MuiCardContent-root': {
          width: 'auto',
        },
      }}
    >
      <ProductTileMiniWrapper sku={sku} index={index} key={key} source="strapi-slider-mobile" />
    </Box>
  </>
)

export const getSlides = (slides, couponSliderSkus = []) =>
  slides
    .map((item, index) => {
      const getKey = generateItemKey(item)
      const View = {
        BaseCategoryTile: item?.CategoryTile && (
          <CategoryTileV2 data={item?.CategoryTile} key={getKey('CategoryTile')} multiLineTitle />
        ),
        BaseProductTile: item?.SKU && renderProductTile(index, item?.SKU, getKey('SKU'), couponSliderSkus),
        PageMarkdown: item?.Markdown && (
          <StrapiMarkdown key={getKey('Markdown')} data={item} gridWrapper={false} Alignment="center" />
        ),
      }
      return View[item.__typename] || null
    })
    .filter(component => Boolean(component))

export const getDesktopBreakpoints = NumOfSlidesDesktop => ({
  0: {
    slidesPerView: 1.25,
  },
  820: {
    slidesPerView: 2.25,
  },
  1024: {
    slidesPerView: NumOfSlidesDesktop === 'default_3_tiles' ? 2.25 : 3.25,
  },
  1280: {
    slidesPerView: NumOfSlidesDesktop === 'default_3_tiles' ? 3.25 : 4.25,
  },
})

export const getMobileBreakpoints = isProductTileSlider => ({
  0: {
    slidesPerView: isProductTileSlider ? 'auto' : 2.25,
  },
})
